import { Height } from '@mui/icons-material';
import React, { useState } from 'react'
import TagComp from '../../NewComponent/Tag/TagComp';
import { Tag } from 'antd';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action/index';
import { Tooltip } from '@mui/material';
import TooltipComp from '../../NewComponent/ToolTip/TooltipComp';

export default function Tags({ data, edit, setEdit, clarified }) {
  const expertState = useSelector((state) => state.expertOpenData);
  const dispatch = useDispatch();
  const { getkeyTagPayload } = bindActionCreators(Actions, dispatch)
  const containerStyle = {
    border: '1px solid #F6F7F8',
    marginBlock: '10px',
    borderRadius: '6px',
    background: '#F6F7F8',
    padding: '12px',
    minHeight: '48px',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap:'5px'
  }
  const textStyles = {
    fontSize: "14px",
    color: "#2A364A",
    lineHeight: "22px",
    fontWeight: "300",
    display: 'flex',
    marginTop: window.devicePixelRatio === 3 ? "7px" : null,
    marginBottom: window.devicePixelRatio === 3 ? "5px" : null,
  };


  const requestClarificationStyles = {
    borderRadius: '6px',
    height: '24px',
    padding: '1px 8px',
    color: '#fff',
    textAlign: 'center',
    background: 'linear-gradient(90.39deg, rgb(255, 160, 80) 0%, #fd7400 50%, rgb(197, 55, 0) 100%)',
    fontSize: '13px',
    marginLeft: '5px',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  };

  const requestedUpdateStyles = {
    borderRadius: '6px',
    height: '24px',
    padding: '1px 8px',
    color: '#fff',
    textAlign: 'center',
    background: 'linear-gradient(90.39deg, rgb(108, 148, 186) 0%, rgb(63, 102, 155) 40%, rgb(58, 99, 144) 100%)',
    fontSize: '13px',
    marginLeft: '5px',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center'
  }

  const requestClarifiedStyles = {
    borderRadius: '6px',
    height: '24px',
    padding: '1px 8px',
    color: '#fff',
    textAlign: 'center',
    background: 'linear-gradient(90.39deg, #28a745 0%, #218838 50%, #19692c 100%)',
    fontSize: '13px',
    marginLeft: '5px',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center'
  }

  const stylesForEmployeeType = {
    // border: '1.2px solid #E0E2E6',
    borderRadius: '6px',
    height: '24px',
    padding: '1px 8px 1px 8px',
    color: '#fff',
    textAlign: 'center',
    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
    fontSize: '13px',
    marginLeft: '5px',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
    cursor: 'default'
  }

  const [tags, setTags] = useState([]);
  const onClickTag = (dt) => {
    let filteredData = tags.filter((tag => {
      return tag.term === dt;
    }));
    getkeyTagPayload({ tag: filteredData[0].term, key: 'expert' });
  }

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  // const askSourceRender = () => {
  //   if (data.askSource === 'csv') {
  //     return (<span style={{ marginBottom: "0px",}}>via&nbsp;<i className="fa fa-file-excel-o" style={{ color: "#875c99" }} title="User added QA via XLS Atomizer"></i></span>)
  //   }
  //   if (data.askSource === 'Mobile')
  //     return (
  //       <><span>via&nbsp;</span><img src={require('../../Images/32x32.png')} style={{ width: "16px" }} /></>
  //     )
  //   if (data.askSource === 'expert-QA') {
  //     return (
  //       <span>via
  //         <TooltipComp children={<>&nbsp;<i class="fa fa-user-plus" aria-hidden="true" style={{ color: "#fb7432" }} /></>
  //         } title={"User added QA via Expert role"}>
  //         </TooltipComp>
  //       </span>
  //     )
  //   }
  //   if (data.askSource === 'slack') {
  //     return (
  //       <><span>via&nbsp;</span><img title="User searched via Slack Vizerto bot" src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></>
  //     )
  //   }
  //   if (data.askSource === 'slackChannel') {
  //     return (
  //       <><span>via&nbsp;</span><img title="User asked a question on slack channel" src={require("../../Images/slack-channel.png")} style={{ width: "16px" }} /></>
  //     )
  //   }
  //   if (data.askSource === 'msteams') {
  //     return (
  //       <><span>via&nbsp;</span><img title="User asked a question via MS Teams" src={require("../../Images/msteams.ico")} style={{ width: "16px",height:"16px",marginBottom:'4px' }} /></>
  //     )
  //   }
  //   if (data.askSource === 'webex') {
  //     return (
  //       <><span>via&nbsp;</span><img title="User asked a question via Webex" src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></>
  //     )
  //   }
  //   if (data.askSource === 'webex-channel') {
  //     return (
  //       <><span>via&nbsp;</span><img title="User asked a question via Webex channel" src={require("../../Images/webex.jpg")} style={{ width: "16px" }} /></>
  //     )
  //   }
  //   if (data.askSource === 'email') {
  //     return (
  //       <><span>via&nbsp;<i title="User asked a question via Email" class="fa fa-envelope" aria-hidden="true" style={{ color: "#875c99" }}></i></span></>
  //     )
  //   }
  // }

  const askSourceRender = () => {
      if (data.askSource === 'csv') {
        return (
          <span style={{ marginBottom: "0px" }}>
            via&nbsp;
            <TooltipComp title="User added QA via XLS Atomizer">
              <i className="fa fa-file-excel-o" style={{ color: "#875c99" }}></i>
            </TooltipComp>
          </span>
        );
      }
    
      if (data.askSource === 'Mobile') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question via Mobile">
              <img src={require('../../Images/32x32.png')} style={{ width: "16px",height:'16px',marginTop:'3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'expert-QA') {
        return (
          <span>
            via&nbsp;
            <TooltipComp title="User added QA via Expert role">
              <i className="fa fa-user-plus" aria-hidden="true" style={{ color: "#fb7432" }} />
            </TooltipComp>
          </span>
        );
      }
    
      if (data.askSource === 'slack') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User searched via Slack Vizerto bot">
              <img src={require("../../Images/slack-channel.png")} style={{ width: "16px",height:'16px',marginTop:'3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'slackChannel') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question on Slack channel">
              <img src={require("../../Images/slack-channel.png")} style={{ width: "16px",height:'16px',marginTop:'3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'msteams') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question via MS Teams">
              <img src={require("../../Images/msteams.ico")} style={{ width: "16px", height: "16px", marginTop: '3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'webex') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question via Webex">
              <img src={require("../../Images/webex.jpg")} style={{ width: "16px",height:"16px",marginTop:'3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'webex-channel') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question via Webex channel">
              <img src={require("../../Images/webex.jpg")} style={{ width: "16px",height:"16px",marginTop:'3px' }} />
            </TooltipComp>
          </>
        );
      }
    
      if (data.askSource === 'email') {
        return (
          <>
            <span>via&nbsp;</span>
            <TooltipComp title="User asked a question via Email">
              <i className="fa fa-envelope" aria-hidden="true" style={{ color: "#875c99" }} />
            </TooltipComp>
          </>
        );
      }
    
  }

  useEffect(() => {
    if (expertState.keyTagsData !== null && expertState.keyTagsData[data.questionUuid] !== undefined && expertState.keyTagsData[data.questionUuid] !== null) {
      setTags(expertState.keyTagsData[data.questionUuid].filter(tag => tag.clickable))
    }
  }, [expertState.keyTagsData]);

  return (
    <>
      <div style={containerStyle} >
        {<div style={textStyles}>Domain&nbsp;<TagComp title={data.domain} />&nbsp;&nbsp;</div>}
        {tags && tags.length !== 0 && <div style={textStyles}>Tags&nbsp;{tags.map(tag => {
          if (tag.clickable) {
            return <TagComp key={tag.term} title={tag.term} onClickFunc={()=>onClickTag(tag.term)} />
          }
        })}&nbsp;&nbsp;</div>}
        {/* {data.clarificationStatus && (
        <div style={textStyles}>{"  "}Status:{"  "}
        <div onClick={()=>setEdit(!edit)} style={requestClarificationStyles}>Expert Requested For Clarification</div></div>)} */}
        <div style={textStyles}>&nbsp;Asked By&nbsp;<div style={stylesForEmployeeType}>
          {/* <Tooltip arrow placement='right' title={capitalizeFirstLetter(data.postedUserFirstName) + " " + capitalizeFirstLetter(data.postedUserLastName)}>{data.userType}</Tooltip> */}
          <TooltipComp title={capitalizeFirstLetter(data.postedUserFirstName) + " " + capitalizeFirstLetter(data.postedUserLastName)} children={data.userType} />
          </div>
          &nbsp;&nbsp; 
          </div>
        {(data.askSource !== 'Vizerto' && data.askSource !== 'External Search') && (
          <div style={textStyles}>&nbsp;Asked&nbsp;{askSourceRender()}&nbsp;&nbsp;</div>
        )}
         {
          ((data.clarifications && data.clarifications.length > 0 && data.clarificationStatus) || data.userInitiatedCuration || clarified) && (
            <div style={textStyles}>
              Status&nbsp;
              {data.userInitiatedCuration && (<><div style={requestedUpdateStyles}>Requested Update</div></>)}
              {/* {data.clarificationStatus && <div style={requestClarificationStyles} onClick={()=>setEdit(!edit)}>Expert Requested For Clarification</div>} */}
              {data.questionStatus !== 'answered' && data.clarificationStatus === true && data.clarifications.length > 0 && (
                <>
                  <div style={requestClarificationStyles} onClick={() => setEdit(!edit)}>
                    Clarification Pending
                  </div>
                </>
              )
              }
              {clarified && (
                <>
                  <span>Status&nbsp;</span>
                  <div style={requestClarifiedStyles}>Request Clarified</div>
                </>
              )}
            </div>
          )
        }
      </div>
    </>
  )
}

/* Previous condition backup start */
// {
//   (data.clarificationStatus || data.userInitiatedCuration || clarified) && (
//     <div style={textStyles} className="tags-layer">
//       {data.userInitiatedCuration && (<><span>Status:</span><div style={requestedUpdateStyles}>Requested Update</div></>)}
//       {/* {data.clarificationStatus && <div style={requestClarificationStyles} onClick={()=>setEdit(!edit)}>Expert Requested For Clarification</div>} */}
//       {data.questionStatus !== 'answered' && data.clarificationStatus === true && data.clarifications.length > 0 && (
//         <>
//           <span>Status:</span>
//           <div style={requestClarificationStyles} onClick={() => setEdit(!edit)}>
//             Clarification Pending
//           </div>
//         </>
//       )
//       }
//       {clarified && (
//         <>
//           <span>Status:</span>
//           <div style={requestClarifiedStyles}>Request Clarified</div>
//         </>
//       )}
//     </div>
//   )
// }
/* Previous condition backup end */
